import { PAGE_SIZE, type PrescriptionsReportFilters } from "./types";

const emptyToNull = (value: string): string | null => {
  const trimmed = value.trim();
  return trimmed === "" ? null : trimmed;
};

export function buildReportRpcParams(filters: PrescriptionsReportFilters, pageSize: number = PAGE_SIZE) {
  return {
    p_from: filters.from,
    p_to: filters.to,
    p_search: emptyToNull(filters.search),
    p_sequence: filters.mapaMode === "with" ? emptyToNull(filters.sequence) : null,
    p_vet_id: emptyToNull(filters.vetId),
    p_mapa_mode: filters.mapaMode,
    // O campo de sequencial só vale quando o filtro exige numeração MAPA.
    p_page: filters.page,
    p_page_size: pageSize,
  };
}
